import { provide, inject, Ref, ref } from "vue";

/**
 * Generates the provide/inject methods, setting up with types and defaults.
 * @param sym Symbol for the provide/inject contexts
 * @param defaults data returned when nothing provided;
 */
export function useProvideInject<T>(sym: symbol, defaults: T) {
  return {
    provider(ctx: Ref<T>): void {
      provide<Ref<T>>(sym, ctx);
    },
    injector(): Ref<T> {
      const result = inject<Ref<T>>(sym);
      if (result) {
        return result;
      }

      return ref(defaults) as Ref<T>;
    }
  };
}
